import React from 'react'
import Link from 'gatsby-link'
import { Grid, Row, Col } from 'react-flexbox-grid'

import styles from './EventListItem.module.css'
import Text from '../shared/Text'

const EventListItem = ({
  title,
  displayDate,
  location,
  description,
  slug,
  ...rest
}) => {
  return (
    <Grid {...rest} className={styles.eventListItem}>
      <Row>
        <Col xs={12} sm={4} style={{borderRight: '1px solid #dadada', marginBottom: '2rem', fontWeight: 'bold', textAlign: 'center'}}>{displayDate}</Col>
        <Col xs={12} sm={8}>
          <Text>{description}</Text>
          <Text style={{ borderTop: '1px solid #dadada', paddingTop: '1rem' }}>
            Ort: {location}
          </Text>
          <Text>
            <div className={styles.linkContainer}>
              <Link
                to={slug}
                style={{
                  textDecoration: 'none',
                  color: '#334664',
                  fontWeight: 'bold',
                }}
              >
                Erfahre mehr!
              </Link>
            </div>
          </Text>
        </Col>
      </Row>
    </Grid>
  )
}

export default EventListItem



// WEBPACK FOOTER //
// ./src/components/events/EventListItem.js